
<template>
  <CriterionsModal
    :default-table-name="defaultTableName"
    :default-operation-type="operationType"
    :default-criterion="searchCriterion"
    :entities-list="entitiesList"
    @on-operation-type-select="setOperationType"
    @on-entity-type-select="setEntityType"
    @on-criterion-select="setSearchCriterion"
    @close="$emit('close')"
    with-operation-types
  />
</template>

<script>
import CriterionsModal from '@/_shared/widgets/CriterionsModal';
import store from '@/stock/store';
import { stockMovement } from '@/stock/constants';
export default {
  props: {
    defaultTableName: {
      type: String,
      default: 'all',
    },
  },
  emits: [
    'close',
    'on-entity-select',
  ],
  components: {
    CriterionsModal,
  },
  data() {
    return {
      entitiesList: stockMovement.entities,
    };
  },
  computed: {
    operationType() {
      return store.state.newOperations.operationType;
    },
    searchCriterion() {
      return store.state.newOperations.searchCriterion;
    },
  },
  methods: {
    setSearchCriterion(value) {
      store.dispatch('newOperations/setSearchCriterion', value);
      this.$emit('on-criterion-select');
    },
    setEntityType(value) {
      this.$emit('on-entity-select', value);
    },
    setOperationType(value) {
      store.dispatch('newOperations/setOperationType', value);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/stock/widgets/new-operations/SearchCriterionsModal.vue